import useScreenSize from '../../hooks/useScreenSize'
import BreadCrumbs from '../../components/breadcrumb/Breadcrumb'
import { numbers, ROUTES_PATH, UI_CONSTANT } from '../../utility/constants'
import './dashboard.scss'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import Paper from '@mui/material/Paper'
import { styled } from '@mui/material/styles'
import facultyIcon from '../../assets/icons/Faculty.svg'
import walkInIcon from '../../assets/icons/walkin-icon.svg'
import userIcon from '../../assets/icons/student-user-icon.svg'
import feesIcon from '../../assets/icons/fees-icon-red.svg'
import PageDropdown from '../../components/page-dropdown/PageDropdown'
import ParentDataTable from '../../components/data-table/ParentDataTable'
import { useCallback, useEffect, useRef, useState } from 'react'
import MovetoWalkIn from '../../assets/icons/MoveToWalkIn.svg'
import EnrollIcon from '../../assets/icons/enroll-icon.svg'
import PopupBox from '../../components/popup/PopupBox'
import pencilicon from '../../assets/icons/pencil1.svg'
import HorizontalLine from '../../assets/icons/Line33.svg'
import TackFollowUp from '../../assets/icons/TakeFollowUp.svg'
import phoneIcon from '../../assets/icons/phoneIcon.svg'
import MailIcon from '../../assets/icons/MailIcon.svg'
import ArchiveIcon from '../../assets/icons/archive.svg'
import ModalUnstyled from '../../components/model/Model'
import { getInquiries, getPriorityInquiries } from '../../store/builders/inquiry/inquiry.builder'
import { capitalizeFirstLetter, convertTZToDate } from '../../utility/genricFunction'
import BarChart from '../../components/barChart/BarChart'
import { getDashboardData } from '../../store/builders/dashboard/dashboard.builder'
import ReportDataTable from '../../components/report-table/ReportDataTable'
import Loader from '../../components/loader/Loader'
import ServerParentDataTable from '../../components/data-table/ServerParentDataTable'

const Dashboard = () => {
  const screenSize = useScreenSize()
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const roleSelector = useSelector((store) => store.auth)
  const { allInquiryData, inquiryPageData } = useSelector((state) => state.inquiry)
  const userRole = roleSelector?.user?.result?.userData?.roleName
  const { priorityInquiryData } = useSelector((state) => state.inquiry)
  const popupRef = useRef(null)
  const [anchor, setAnchor] = useState(null)
  const { dashboardData, loading } = useSelector((store) => store.dashboard)
  const [filters, setFilters] = useState({})

  useEffect(() => {
    dispatch(getDashboardData())
    dispatch(getInquiries(filters))
    return () => dispatch({ type: 'dashboard/clearExtraReducers' })
  }, [])
  function getFormattedDate(date) {
    const year = date.getFullYear()
    const month = String(date.getMonth() + 1).padStart(2, '0') // Months are zero-based
    const day = String(date.getDate()).padStart(2, '0')
    return `${year}-${month}-${day}`
  }

  const today = new Date()
  const tomorrow = new Date()
  const nextThreeDate = new Date()

  tomorrow.setDate(today.getDate() + 1)
  nextThreeDate.setDate(today.getDate() + 2)

  const formattedToday = getFormattedDate(today)
  const formattedTomorrow = getFormattedDate(tomorrow)
  const formatteNextThreeDate = getFormattedDate(nextThreeDate)

  const [selectedNumber, setSelectedNumber] = useState(numbers[0].value)
  const [selectedInquiryNumber, setSelectedInquiryNumber] = useState(5)
  const [page, setPage] = useState(1)

  const apiCallOnPagination = useCallback(() => {
    const newFilters = { ...filters }

    newFilters.limit = {
      value: selectedInquiryNumber,
      matchMode: 'startsWith',
    }

    newFilters.page = {
      value: page,
      matchMode: 'startsWith',
    }
    dispatch(getInquiries(newFilters))
  }, [selectedInquiryNumber, page])

  useEffect(() => {
    if (userRole == UI_CONSTANT.INQUIRY_ROLE) {
      dispatch(getPriorityInquiries({ inquiry_date_from: formattedToday, inquiry_date_to: formattedTomorrow }))
    }
    apiCallOnPagination()
  }, [])

  useEffect(() => {
    apiCallOnPagination()
  }, [selectedInquiryNumber, page])
  const handlePopByRoles = (InquiresRowData, handleEnrollRowClick, handleClickBranch) => {
    return userRole === UI_CONSTANT.ADMIN_ROLE || userRole === UI_CONSTANT.BRANCH_ROLE ? (
      <>
        {InquiresRowData && InquiresRowData.type == 'Walkin' ? (
          <button
            className='div-assign-to-branch'
            disabled={InquiresRowData?.inquiryArchiveStatus == 'archive' ? true : false}
            onClick={() => handleEnrollRowClick(InquiresRowData.id)}
          >
            <img src={EnrollIcon} alt='' />
            <p
              className={`${InquiresRowData?.inquiryArchiveStatus == 'archive' ? 'verifiedBodyTemplate-darkfont popup-font' : 'verifiedBodyTemplate-darkfont'}`}
            >
              Enroll Now
            </p>
          </button>
        ) : (
          <button
            className='div-assign-to-branch'
            disabled={InquiresRowData?.inquiryArchiveStatus == 'archive' ? true : false}
            onClick={handleClickBranch}
          >
            <img src={MovetoWalkIn} alt='' />
            <p
              className={`${InquiresRowData?.inquiryArchiveStatus == 'archive' ? 'verifiedBodyTemplate-darkfont popup-font' : 'verifiedBodyTemplate-darkfont'}`}
            >
              Move to Walk-In
            </p>
          </button>
        )}
      </>
    ) : (
      <>
        {InquiresRowData && InquiresRowData.type !== 'Walkin' ? (
          <button
            className='div-assign-to-branch'
            disabled={InquiresRowData?.inquiryArchiveStatus == 'archive' ? true : false}
            onClick={handleClickBranch}
          >
            <img src={MovetoWalkIn} alt='' />
            <p
              className={`${InquiresRowData?.inquiryArchiveStatus == 'archive' ? 'verifiedBodyTemplate-darkfont popup-font' : 'verifiedBodyTemplate-darkfont'}`}
            >
              Move to Walk-In
            </p>
          </button>
        ) : (
          ''
        )}
      </>
    )
  }

  const breadCrumbsArr = [
    {
      title: UI_CONSTANT.DASHBOARD,
      link: null,
    },
  ]

  const nameBody = (allInquiryData) => {
    const representative = capitalizeFirstLetter(allInquiryData.name)
    return (
      <div className='flex align-items-center gap-2'>
        <span>{representative}</span>
      </div>
    )
  }
  const typeBody = (allInquiryData) => {
    const representative = capitalizeFirstLetter(allInquiryData.inquiryType)
    return (
      <div className='flex align-items-center gap-2'>
        <span>{representative}</span>
      </div>
    )
  }
  const statusBody = (allInquiryData) => {
    const representative = capitalizeFirstLetter(allInquiryData.inquiryStatus)
    return (
      <div className='flex align-items-center gap-2'>
        <span>{representative}</span>
      </div>
    )
  }
  const branchBody = (allInquiryData) => {
    const representative = allInquiryData?.branchName && capitalizeFirstLetter(allInquiryData?.branchName)
    return (
      <div className='flex align-items-center gap-2'>
        <span>{representative}</span>
      </div>
    )
  }

  const [openArchive, setOpenArchive] = useState(false)

  const handleArchive = () => setOpenArchive(true)

  const verifiedBodyTemplate = (priorityInquiryData) => {
    const handleOnButtonClick = (id) => {
      const path = ROUTES_PATH.FOLLOW_UP_LIST_CREATE.replace(':id', id)
      navigate(path)
    }
    const handleClickBranch = () => {
      navigate('/inquiry/new-inquiry')
    }
    const handleRowClick = (id) => {
      const path = ROUTES_PATH.EDIT_INQUIRY.replace(':id', id)
      navigate(path)
    }
    const handleEnrollRowClick = (id) => {
      const path = ROUTES_PATH.EDIT_ENROLLMENT.replace(':id', id)
      navigate(path)
    }

    return (
      <>
        <PopupBox rowData={priorityInquiryData} setAnchor={setAnchor} anchor={anchor} popupRef={popupRef}>
          <div className='popupbox'>
            <p className='verifiedBodyTemplate-Assign'>{UI_CONSTANT.POP_UP_ACTION}</p>

            {handlePopByRoles(priorityInquiryData, handleEnrollRowClick, handleClickBranch)}

            <button
              className='div-assign-to-branch'
              disabled={priorityInquiryData?.inquiryArchiveStatus == 'archive' ? true : false}
              onClick={() => handleOnButtonClick(priorityInquiryData.inquiryId)}
            >
              <img src={TackFollowUp} alt='' />
              <p
                className={`${priorityInquiryData?.inquiryArchiveStatus == 'archive' ? 'verifiedBodyTemplate-darkfont popup-font' : 'verifiedBodyTemplate-darkfont'}`}
              >
                Take Follow-Up
              </p>
            </button>
            <img src={HorizontalLine} alt='' />
            <button className='div-assign-to-branch'>
              <img src={phoneIcon} alt='' />
              <p className='verifiedBodyTemplate-darkfont'>+91-{priorityInquiryData?.phone}</p>
            </button>
            <button className='div-assign-to-branch'>
              <img src={MailIcon} alt='' />
              <p className='verifiedBodyTemplate-darkfont'>{priorityInquiryData?.email}</p>
            </button>
            <img src={HorizontalLine} alt='' />
            <button
              className='div-assign-to-branch'
              disabled={priorityInquiryData?.inquiryArchiveStatus == 'archive' ? true : false}
              onClick={() => handleRowClick(priorityInquiryData.inquiryId)}
            >
              <img src={pencilicon} alt='' />
              <p
                className={`${priorityInquiryData?.inquiryArchiveStatus == 'archive' ? 'verifiedBodyTemplate-darkfont popup-font' : 'verifiedBodyTemplate-darkfont'}`}
              >
                Edit
              </p>
            </button>
            <button
              className='div-assign-to-branch'
              disabled={priorityInquiryData?.inquiryArchiveStatus == 'archive' ? true : false}
              onClick={handleArchive}
            >
              <img src={ArchiveIcon} alt='' />
              <p
                className={`${priorityInquiryData?.inquiryArchiveStatus == 'archive' ? 'verifiedBodyTemplate-darkfont popup-font' : 'verifiedBodyTemplate-darkfont'}`}
              >
                Archive
              </p>
            </button>
          </div>
        </PopupBox>
        {openArchive && (
          <ModalUnstyled
            open={openArchive}
            setOpen={setOpenArchive}
            title={'Archive'}
            BottomButton={'Yes'}
            BottomButton2={'No'}
          >
            <div className='model-archive'>
              <p>{UI_CONSTANT.ARCHIVE_MESSAGE}</p>
            </div>
          </ModalUnstyled>
        )}
      </>
    )
  }

  const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
    ...theme.typography.body2,
    padding: theme.spacing(1),
    textAlign: 'center',
    color: theme.palette.text.secondary,
  }))

  const cardDetails = [
    {
      title: dashboardData?.telephonicFollowUpsCount ? dashboardData?.telephonicFollowUpsCount : 0,
      subTitle: 'Telephonic Followups',
      iconSrc: facultyIcon,
      link: ROUTES_PATH.INQUIRY,
    },
    {
      title: dashboardData?.walkinFollowUpsCount ? dashboardData?.walkinFollowUpsCount : 0,
      subTitle: 'Walk-In Followups',
      iconSrc: walkInIcon,
      link: ROUTES_PATH.INQUIRY,
    },
    {
      title: dashboardData?.totalStudentsCount ? dashboardData?.totalStudentsCount : 0,
      subTitle: 'Total Students',
      iconSrc: userIcon,
      link: ROUTES_PATH.ENROLLMENT,
    },
    {
      title: dashboardData?.feesDueInNext3DaysCount ? dashboardData?.feesDueInNext3DaysCount : 0,
      subTitle: 'Fees due in next 3 days',
      iconSrc: feesIcon,
      applyOriginal: true,
      rupeeState: true,
      link: ROUTES_PATH.TOTAL_DUE_FEES,
    },
    {
      title: dashboardData?.totalFeesDueCount ? dashboardData?.totalFeesDueCount : 0,
      subTitle: `Total Fees Due`,
      iconSrc: feesIcon,
      applyOriginal: true,
      rupeeState: true,
      link: ROUTES_PATH.TOTAL_DUE_FEES,
    },
    {
      title: dashboardData?.totalFacultyCount ? dashboardData?.totalFacultyCount : 0,
      subTitle: 'Total Faculty',
      iconSrc: facultyIcon,
      link: ROUTES_PATH.FACULTY,
    },
  ]
  const inquiryRoleCardDetails = [
    {
      title: dashboardData?.telephonicFollowUpsCount ? dashboardData?.telephonicFollowUpsCount : 0,
      subTitle: 'Telephonic Followups',
      iconSrc: facultyIcon,
      link: ROUTES_PATH.INQUIRY,
    },
    {
      title: dashboardData?.walkinFollowUpsCount ? dashboardData?.walkinFollowUpsCount : 0,
      subTitle: 'Walk-In Followups',
      iconSrc: walkInIcon,
      link: ROUTES_PATH.INQUIRY,
    },
  ]

  const columns = [
    {
      sortable: true,
      field: 'name',
      header: 'Name',
      filter: false,
      filterDisplay: 'row',
      style: { minWidth: '12rem' },
      body: nameBody,
    },
    {
      sortable: true,
      field: 'inquiryType',
      header: 'Type',
      style: { minWidth: '12rem' },
      filterMenuStyle: { width: '14rem' },
      filter: false,
      body: typeBody,
    },
    {
      sortable: true,
      field: 'courseName',
      header: 'Course Name',
      filter: false,
      filterDisplay: 'row',
      style: { minWidth: '12rem' },
    },
    {
      sortable: true,
      field: 'nextFollowupDate',
      header: 'Next Followup',
      filter: false,
      filterDisplay: 'row',
      style: { minWidth: '12rem' },
      filterPlaceholder: 'Search by date...',
    },
    {
      sortable: true,
      field: 'branchName',
      header: 'Branch',
      filter: false,
      filterDisplay: 'row',
      style: { minWidth: '12rem' },
    },
    {
      sortable: true,
      field: 'inquiryStatus',
      header: 'Status',
      showFilterMenu: false,
      filterMenuStyle: { width: '5rem' },
      style: { minWidth: '10rem' },
      body: statusBody,
      filter: false,
    },
    {
      sortable: false,
      field: 'verified',
      header: '',
      dataType: 'boolean',
      style: { maxWidth: '4rem' },
      body: verifiedBodyTemplate,
      filter: false,
    },
  ].filter((column) => {
    if (
      column.field.toLowerCase() == 'branch' &&
      (userRole.toLowerCase() == UI_CONSTANT.BRANCH_ROLE || userRole.toLowerCase() == UI_CONSTANT.INQUIRY_ROLE)
    ) {
      return false
    } else {
      return true
    }
  })

  const inquiryColumns = [
    {
      sortable: true,
      field: 'name',
      header: 'Name',
      filter: false,
      style: { minWidth: '12rem' },
      body: nameBody,
    },
    {
      sortable: true,
      field: 'inquiryType',
      header: 'Type',
      style: { minWidth: '12rem' },
      filter: false,
      body: typeBody,
    },
    {
      sortable: true,
      field: 'courseName',
      header: 'Course Name',
      filter: false,
      style: { minWidth: '12rem' },
    },
    {
      sortable: true,
      field: 'inquiryDate',
      header: 'Date',
      filter: false,
      style: { minWidth: '19rem', backgroundColor: 'transparent' },
    },
    {
      sortable: true,
      field: 'nextFollowupDate',
      header: 'Next Followup',
      filter: false,
      style: { minWidth: '12rem' },
    },
    {
      sortable: true,
      field: 'branchName',
      header: 'Branch',
      filter: false,
      style: { minWidth: '12rem' },
      body: branchBody,
    },
    {
      sortable: true,
      field: 'inquiryStatus',
      header: 'Status',
      filter: false,
      style: { minWidth: '10rem' },
      body: statusBody,
    },
  ].filter((column) => {
    if (
      column.field.toLowerCase() == 'branch' &&
      (userRole.toLowerCase() == 'branch' || userRole.toLowerCase() == 'inquiry')
    ) {
      return false
    } else {
      return true
    }
  })

  const [filteredData] = useState([])
  const [filterNumber] = useState(false)

  const columnsCourseEnrollment = [
    {
      // sortable: true,
      field: 'course_name',
      header: 'Course',
      filter: true,
      filterDisplay: 'row',
      filterPlaceholder: 'Search by name...',
      style: { minWidth: '12rem' },
      // body: nameBody,
    },
    {
      // sortable: true,
      field: 'enrollment_count',
      header: 'Enrollment Count',
      filter: true,
      filterDisplay: 'row',
      filterPlaceholder: 'Search by phone...',
      style: { width: '50%' },
    },
  ]

  const columnsBirthdays = [
    {
      // sortable: true,
      field: 'role_name',
      header: 'Role Name',
      style: { minWidth: '12rem' },
      // body: nameBody,
    },
    {
      // sortable: true,
      field: 'user_name',
      header: 'Name',
      style: { width: '50%' },
    },
    {
      // sortable: true,
      field: 'phone',
      header: 'Phone',
      style: { width: '50%' },
    },
  ]

  function convertToChartData(data, isGrouped = false) {
    const monthsOrder = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sept', 'Oct', 'Nov', 'Dec']

    const startMonthYear = data?.[0]?.month?.split(' ')
    const startMonth = startMonthYear?.[0]
    const startYear = parseInt(startMonthYear?.[1])

    let monthRange = []
    let currentMonthIndex = monthsOrder?.indexOf(startMonth)
    let currentYear = startYear

    for (let i = 0; i < 13; i++) {
      monthRange?.push(`${monthsOrder?.[currentMonthIndex]} ${currentYear}`)
      currentMonthIndex = (currentMonthIndex + 1) % 12
      if (currentMonthIndex === 0) {
        currentYear += 1
      }
    }

    const collections = new Array(13).fill(0)
    const telephonicInquiries = new Array(13).fill(0)
    const walkinInquiries = new Array(13).fill(0)
    const enrollments = new Array(13).fill(0)
    const deadInquiries = new Array(13).fill(0)

    data?.forEach((item) => {
      // eslint-disable-next-line no-unsafe-optional-chaining
      const [monthName, year] = item?.month?.split(' ')
      const monthYear = `${monthName} ${year}`
      const monthIndex = monthRange?.indexOf(monthYear)
      if (monthIndex !== -1) {
        if (isGrouped) {
          telephonicInquiries[monthIndex] = parseInt(item?.telephonic_inquiries_count, 10) || 0
          walkinInquiries[monthIndex] = parseInt(item?.walkin_inquiries_count, 10) || 0
          enrollments[monthIndex] = parseInt(item?.enrollments_count, 10) || 0
          deadInquiries[monthIndex] = parseInt(item?.dead_count, 10) || 0
        } else {
          if (typeof item?.total_collection === 'string') {
            collections[monthIndex] = parseFloat(item?.total_collection?.replace('k', '')) * 1000
          } else {
            collections[monthIndex] = parseFloat(item?.total_collection) || 0
          }
        }
      }
    })

    const chartData = {
      labels: monthRange?.map((month) => {
        const [monthName, year] = month.split(' ')
        const yearSuffix = year.toString().slice(-2)
        return `${monthName} ${yearSuffix}`
      }),
      datasets: [],
    }

    if (isGrouped) {
      chartData.datasets.push(
        {
          label: UI_CONSTANT.ADMIN_DASHBOARD.TELEPHONIC_INQUIRIES,
          data: telephonicInquiries,
          backgroundColor: '#ee4e56',
          borderColor: 'rgba(255, 99, 132, 1)',
          borderWidth: 1,
        },
        {
          label: UI_CONSTANT.ADMIN_DASHBOARD.WALK_IN_INQUIRIES,
          data: walkinInquiries,
          backgroundColor: 'grey',
          borderColor: 'rgba(54, 162, 235, 1)',
          borderWidth: 1,
        },
        {
          label: UI_CONSTANT.ADMIN_DASHBOARD.ENROLLMENT,
          data: enrollments,
          backgroundColor: 'black',
          borderColor: 'rgba(255, 206, 86, 1)',
          borderWidth: 1,
        },
        {
          label: UI_CONSTANT.ADMIN_DASHBOARD.DEAD_INQUIRIES,
          data: deadInquiries,
          backgroundColor: 'rgba(99, 102, 241, 1)',
          borderColor: 'black',
          borderWidth: 1,
        },
      )
    } else {
      chartData.datasets.push({
        label: UI_CONSTANT.ADMIN_DASHBOARD.MONTH_WISE_TOTAL_COLLECTION,
        data: collections,
        backgroundColor: '#ee4e56',
        borderColor: 'rgba(255, 99, 132, 1)',
        borderWidth: 1,
      })
    }

    return chartData
  }

  const singleBarData = convertToChartData(dashboardData?.totalCollectionMonthWise)
  const groupedBarData = convertToChartData(dashboardData?.inquiriesMonthWise, true)

  const handleCardClick = (card, cardType) => {
    let query = ''
    switch (cardType) {
      case 'telephonicFollowUps':
        query = `inquiryType=telephonic&next_followup_date_to=${formattedToday}&next_followup_date_from=${formattedToday}`
        navigate(`${card.link}?${query}`)
        break
      case 'walkinFollowUps':
        query = `inquiryType=walkin&next_followup_date_to=${formattedToday}&next_followup_date_from=${formattedToday}`
        navigate(`${card.link}?${query}`)
        break
      case 'totalStudents':
        navigate(card.link)
        break
      case 'feesDue':
        query = `dueFromDate=${formattedToday}&dueToDate=${formatteNextThreeDate}`
        navigate(`${card.link}?${query}`)
        break
      case 'totalFees':
        query = `dueToDate=${formattedToday}`
        navigate(`${card.link}?${query}`)
        break
      case 'totalFaculty':
        navigate(card.link)
        break
      default:
        break
    }
  }

  return (
    <>
      {loading && <Loader loading={loading} />}
      {<Loader loading={loading} /> && (
        <div className={`course-list dashboard-main ${screenSize}`}>
          <div className='subheader'>
            <BreadCrumbs breadCrumbsArr={breadCrumbsArr} />
          </div>
          <div className='dashboard-stack flex'>
            {userRole !== UI_CONSTANT.INQUIRY_ROLE ? (
              <>
                <div className='dashboard-sub-stack flex justify-between'>
                  {cardDetails?.slice(0, 3)?.map((card, index) => (
                    <Item
                      className='dashboard-card'
                      key={index}
                      sx={{ width: '300px' }}
                      onClick={() =>
                        handleCardClick(
                          card,
                          index === 0 ? 'telephonicFollowUps' : index === 1 ? 'walkinFollowUps' : 'totalStudents',
                        )
                      }
                      style={{ cursor: card.link ? 'pointer' : 'default' }}
                    >
                      <div className='card-details-div'>
                        <span className='card-title-count'>{card?.rupeeState ? `₹ ${card?.title}` : card?.title}</span>
                        <span className='card-sub-title-desc'>{card?.subTitle}</span>
                      </div>
                      <div className='card-icon-avatar'>
                        <img src={card?.iconSrc} className={card?.applyOriginal ? '' : 'avatar-icon'} />
                      </div>
                    </Item>
                  ))}
                </div>
                <div className='dashboard-sub-stack flex justify-between'>
                  {cardDetails?.slice(3, 6)?.map((card, index) => (
                    <Item
                      className='dashboard-card'
                      key={index + 3}
                      sx={{ width: '300px' }}
                      onClick={() =>
                        handleCardClick(card, index === 0 ? 'feesDue' : index === 1 ? 'totalFees' : 'totalFaculty')
                      }
                      style={{ cursor: card.link ? 'pointer' : 'default' }}
                    >
                      <div className='card-details-div'>
                        <span className='card-title-count'>
                          {card?.subTitle?.toLowerCase()?.includes('fees') ? `₹ ${card?.title}` : card?.title}
                        </span>
                        <span className='card-sub-title-desc'>{card?.subTitle}</span>
                      </div>
                      <div className='card-icon-avatar'>
                        <img src={card?.iconSrc} className={card?.applyOriginal ? '' : 'avatar-icon'} />
                      </div>
                    </Item>
                  ))}
                </div>
              </>
            ) : (
              <div className='dashboard-sub-stack flex justify-between'>
                {inquiryRoleCardDetails?.map((card, index) => (
                  <Item
                    className='dashboard-card'
                    key={index + 3}
                    sx={{ width: '300px' }}
                    onClick={() =>
                      handleCardClick(card, index === 0 ? 'feesDue' : index === 1 ? 'totalFees' : 'totalFaculty')
                    }
                    style={{ cursor: card.link ? 'pointer' : 'default' }}
                  >
                    <div className='card-details-div'>
                      <span className='card-title-count'>
                        {card?.subTitle?.toLowerCase()?.includes('fees') ? `₹ ${card?.title}` : card?.title}
                      </span>
                      <span className='card-sub-title-desc'>{card?.subTitle}</span>
                    </div>
                    <div className='card-icon-avatar'>
                      <img src={card?.iconSrc} className={card?.applyOriginal ? '' : 'avatar-icon'} />
                    </div>
                  </Item>
                ))}
              </div>
            )}
          </div>

          {userRole === UI_CONSTANT.INQUIRY_ROLE && (
            <div className='group-parent'>
              <div className='frame-wrapper'>
                <div className='course-list-wrapper'>
                  <b className='course-list1'>Today&apos;s Follow Up</b>
                </div>
              </div>
              <div className='flex page-drop-div'>
                <p className='page-sidetext'>{UI_CONSTANT.TABLE_HEADER_SAW}</p>
                <PageDropdown
                  options={numbers}
                  selectedValue={selectedNumber}
                  onChange={(e) => setSelectedNumber(e.value)}
                  className='w-full md:w-14rem small-dropdown'
                />
                <p className='page-endtext'>{UI_CONSTANT.TABLE_HEADER_ENTRIES}</p>
              </div>

              <div className='table-card action-btn-include'>
                <ParentDataTable
                  value={priorityInquiryData}
                  rows={selectedNumber}
                  loading={loading}
                  globalFilterFields={['name', 'country.name', 'representative.name', 'status']}
                  columns={columns}
                  archiveKey={'inquiryArchiveStatus'}
                />
              </div>
            </div>
          )}
          {/* <div className='flex dashboard-flex-gap'> */}
          {userRole !== UI_CONSTANT.INQUIRY_ROLE && (
            <>
              <label className='dashboard-chart-label'>{UI_CONSTANT.ADMIN_DASHBOARD.COLLECTION_OVERVIEW}</label>
              <BarChart rupeeState={true} data={singleBarData} containerBorderRadius={10} barThickness={10} />
            </>
          )}
          <label className='dashboard-chart-label'>{UI_CONSTANT.ADMIN_DASHBOARD.INQUIRY_OVERVIEW}</label>
          <BarChart data={groupedBarData} />

          <label className='dashboard-chart-label'>{UI_CONSTANT.ADMIN_DASHBOARD.INQUIRY_LIST}</label>
          <div className='table-card' style={{ marginTop: '20px' }}>
            <ServerParentDataTable
              value={allInquiryData}
              rows={selectedInquiryNumber}
              columns={inquiryColumns}
              isServerSide={true}
              pageChange={(e) => setPage(Number(e.page) + 1)}
              totalRecords={inquiryPageData?.totalItems}
              archiveKey='inquiryArchiveStatus'
            />
          </div>
          {/* </div> */}
          <div className='flex justify-between dashboard-flex-gap'>
            <div className={`table-card table-card-dashboard`}>
              <div className='frame-wrapper-dashboard'>
                {/* <b className='dashboard-table-header'>{UI_CONSTANT.USER_MANAGEMENT.ALL_USER}</b> */}
                <b className='dashboard-table-header'>{UI_CONSTANT.ADMIN_DASHBOARD.MONTH_WISE_ENROLLMENT_COUNT}</b>
              </div>
              <ReportDataTable
                value={dashboardData?.courseWiseEnrollment}
                rows={filterNumber ? filteredData.length : selectedNumber}
                // loading={loading2}
                columns={columnsCourseEnrollment}
              />
            </div>

            <div className={`table-card table-card-dashboard`}>
              <div className='frame-wrapper-dashboard'>
                {/* <b className='dashboard-table-header'>{UI_CONSTANT.USER_MANAGEMENT.ALL_USER}</b> */}
                <b className='dashboard-table-header'>
                  {UI_CONSTANT.ADMIN_DASHBOARD.TODAYS_BIRTHDAY} {`(${convertTZToDate(new Date().toISOString())})`}
                </b>
              </div>
              <ReportDataTable
                value={dashboardData?.todaysBirthdays}
                rows={filterNumber ? filteredData.length : selectedNumber}
                // loading={loading2}
                columns={columnsBirthdays}
              />
            </div>
          </div>
        </div>
      )}
    </>
  )
}

export default Dashboard
